<div class="card mt-3">
  <div class="card-header">
    <i class="fa fa-gift"></i> Boosters
  </div>
  <div class="card-body">
    <table class="table table-responsive-sm table-hover table-outline mb-0">
      <thead class="thead-light">
        <tr>
          <th>#</th>
          <th>Rank</th>
          <th>Cards Drop Count</th>
          <th>Drops</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading) {
          <tr>
            <td colspan="5" class="text-center">
              <span class="spinner-border spinner-border-sm"></span> Loading...
            </td>
          </tr>
        } @else if (boosters.length === 0) {
          <tr>
            <td colspan="5" class="text-center text-muted">No booster found.</td>
          </tr>
        } @else {
          @for (booster of boosters; track booster.boosterRankType; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ CollectionCardRankType[booster.boosterRankType] }}</td>
              <td>{{ booster.cardsDropCount }}</td>
              <td>
                @for (drop of booster.drops; track drop.cardRankType) {
                  <span class="badge bg-secondary me-1">
                    {{ CollectionCardRankType[drop.cardRankType] }} : {{ drop.rarityWeight }}
                    @if (getTotalWeight(booster) > 0) {
                      ({{ drop.rarityWeight * 100 / getTotalWeight(booster) | number:'1.0-2' }} %)
                    }
                  </span>
                }
              </td>
              <td>
                <button class="btn btn-sm btn-primary" type="button" (click)="onClickEdit(booster)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>

<app-collection-booster-edit-modal #editModal></app-collection-booster-edit-modal>
